/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EntitySequence } from './EntitySequence';
import {
    EntitySequenceFromJSON,
    EntitySequenceFromJSONTyped,
    EntitySequenceToJSON,
} from './EntitySequence';
import type { SequenceAlign } from './SequenceAlign';
import {
    SequenceAlignFromJSON,
    SequenceAlignFromJSONTyped,
    SequenceAlignToJSON,
} from './SequenceAlign';

/**
 * 
 * @export
 * @interface OpenFilePayload
 */
export interface OpenFilePayload {
    /**
     * 
     * @type {Array<EntitySequence>}
     * @memberof OpenFilePayload
     */
    entitySequences: Array<EntitySequence>;
    /**
     * 
     * @type {Array<SequenceAlign>}
     * @memberof OpenFilePayload
     */
    alignedSequences?: Array<SequenceAlign>;
}

/**
 * Check if a given object implements the OpenFilePayload interface.
 */
export function instanceOfOpenFilePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entitySequences" in value;

    return isInstance;
}

export function OpenFilePayloadFromJSON(json: any): OpenFilePayload {
    return OpenFilePayloadFromJSONTyped(json, false);
}

export function OpenFilePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenFilePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entitySequences': ((json['entitySequences'] as Array<any>).map(EntitySequenceFromJSON)),
        'alignedSequences': !exists(json, 'alignedSequences') ? undefined : ((json['alignedSequences'] as Array<any>).map(SequenceAlignFromJSON)),
    };
}

export function OpenFilePayloadToJSON(value?: OpenFilePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entitySequences': ((value.entitySequences as Array<any>).map(EntitySequenceToJSON)),
        'alignedSequences': value.alignedSequences === undefined ? undefined : ((value.alignedSequences as Array<any>).map(SequenceAlignToJSON)),
    };
}

